// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import Vuetify from 'vuetify'
import BootstrapVue from 'bootstrap-vue'


import 'vuetify/dist/vuetify.min.css'
import 'material-design-icons-iconfont/dist/material-design-icons.css'
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'
import VueSession from 'vue-session'
import VueCountdown from '@xkeshi/vue-countdown';
import VeeValidate from 'vee-validate';


Vue.config.productionTip = false;

var VueCookie = require('vue-cookie');
Vue.use(VueCookie);
Vue.use(VueSession, {persist: true})

Vue.component(VueCountdown.name, VueCountdown)
let locale = 'fr';
Vue.use(VeeValidate, {
  locale: locale,
});


VeeValidate.Validator.extend('verify_password', {
  getMessage: field => `Le mot de passe doit contenir au minimum: 1 lettre majuscule, 1 lettre minuscule, 1 chiffre et un caractère spécial (par exemple,# _ &? Etc)`,
  validate: value => {
    var strongRegex = new RegExp("^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*?[#?!@$%^&*-_+*/=<>,;.:])(?=.{8,})");
    return strongRegex.test(value);
  }
});



Vue.use(Vuetify);
Vue.use(BootstrapVue);
/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js